exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-bg[data-v-418a17e0] {\n    border-radius: 100%;\n    height: 60px;\n    width: 60px;\n    display: inline-block;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.icon-size[data-v-418a17e0] {\n    font-size: 30px;\n}\n.click-pointer[data-v-418a17e0] {\n    cursor: pointer;\n}\n", ""]);

// exports
